export function isNonNullObject(obj) {
  return obj !== null && typeof obj === 'object';
} //# sourceMappingURL=objects.js.map